module.exports = __webpack_public_path__ + "static/unimelb_logo-d0a1fffc2dd2ea561b3349c41554af04.svg";